<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <CoursePage />
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import CoursePage   from '@/components/view_blocks/Course/Course_wrap.vue';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    CoursePage,
  },
};
</script>
